import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToasterModule } from 'angular2-toaster/angular2-toaster';

import { NgSelectModule } from '@ng-select/ng-select';
import { TextMaskModule } from 'angular2-text-mask';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxLoadingModule } from 'ngx-loading';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

 import { ColorsService } from './colors/colors.service';

import { TabDirective } from './directives/tab/tab.directive';
import { TabService } from './directives/tab/tab.service';
import { AutofocusDirective } from './directives/tab/autofocus.directive'
import { NumericDirective } from './directives/tab/number.directive'
import { UploadModule } from '@progress/kendo-angular-upload';

import { LinkViewComponent } from '../shared/components/public/linkview.component';
import { ButtonViewComponent } from '../shared/components/public/buttonview.component';
import { NumberViewComponent } from '../shared/components/public/numberview.component';
import { DateViewComponent } from '../shared/components/public/dateview.component';
import { RowExpandViewComponent } from '../shared/components/public/rowexpandview.component';
import { RowHoaHongViewComponent } from '../shared/components/public/rowhoahongview.component';
import { HideIfUnauthorizedDirective } from './directives/hide-if-unauthorized.directive';
import { DisableIfUnauthorizedDirective } from './directives/disable-if-unauthorized.directive';
import { Repository } from '../services/repository'
import { AuthorizationService } from '../services/authorization.service'
import { ToasterService } from 'angular2-toaster/angular2-toaster';

import { noptncnceditComponent } from './components/ketoan/noptncncedit.component'
import { muacongcueditComponent } from './components/ketoan/muacongcuedit.component'
import { phanbocongcueditComponent } from './components/ketoan/phanbocongcuedit.component'
import { phongbaneditComponent } from './components/danhmuc/phongbanedit.component'
import { chuyentieptaisaneditComponent } from './components/danhmuc/chuyentieptaisanedit.component'
import { dccongcueditComponent } from './components/ketoan/dccongcuedit.component'
import { dctaisaneditComponent } from './components/ketoan/dctaisanedit.component'
import { ghigiamcongcueditComponent } from './components/ketoan/ghigiamcongcuedit.component'
import { ghitangcongcueditComponent } from './components/ketoan/ghitangcongcuedit.component'
import { xuatkhoeditComponent } from './components/ketoan/xuatkhoedit.component'
import { congcueditComponent } from './components/danhmuc/congcuedit.component'
import { nhapkhoeditComponent } from './components/ketoan/nhapkhoedit.component'
import { haomoneditComponent } from './components/ketoan/haomonedit.component'
import { bantaisaneditComponent } from './components/ketoan/bantaisanedit.component'
import { nhantaisaneditComponent } from './components/ketoan/nhantaisanedit.component'
import { cktaisaneditComponent } from './components/ketoan/cktaisanedit.component'
import { loaitaisaneditComponent } from './components/danhmuc/loaitaisanedit.component'
import { taikhoanketchuyeneditComponent } from './components/danhmuc/taikhoanketchuyenedit.component'
import { giudutoaneditComponent } from './components/ketoan/giudutoanedit.component'
import { loccamketchiComponent } from './components/ketoan/loccamketchi.component'
import { dccamketchieditComponent } from './components/ketoan/dccamketchiedit.component'
import { camketchieditComponent } from './components/ketoan/camketchiedit.component'
import { cknoiboeditComponent } from './components/ketoan/cknoiboedit.component'
import { bamgkectuComponent } from './components/ketoan/bamgkectu.component'
import { bangkethanhtoaneditComponent } from './components/ketoan/bangkethanhtoanedit.component'
import { dckinhphieditComponent } from './components/ketoan/dckinhphiedit.component'
import { nganhangeditComponent } from './components/ketoan/nganhangedit.component'
import { rutdutoanckeditComponent } from './components/ketoan/rutdutoanckedit.component'
import { chungtukhaceditComponent } from './components/ketoan/chungtukhacedit.component'
import { rutdutoantgeditComponent } from './components/ketoan/rutdutoantgedit.component'
import { rutdutoantmeditComponent } from './components/ketoan/rutdutoantmedit.component'
import { dcdutoaneditComponent } from './components/ketoan/dcdutoanedit.component'
import { huydutoaneditComponent } from './components/ketoan/huydutoanedit.component'
import { nhandutoaneditComponent } from './components/ketoan/nhandutoanedit.component'
import { baonoeditComponent } from './components/ketoan/baonoedit.component'
import { baocoeditComponent } from './components/ketoan/baocoedit.component'
import { doituongdichvueditComponent } from './components/ketoan/doituongdichvuedit.component'
import { doituongchungeditComponent } from './components/ketoan/doituongchungedit.component'
import { canboeditComponent } from './components/ketoan/canboedit.component'
import { khachhangeditComponent } from './components/ketoan/khachhangedit.component'
import { phieuthueditComponent } from './components/ketoan/phieuthuedit.component'
import { phieuchieditComponent } from './components/ketoan/phieuchiedit.component'
import { maubaocaoeditComponent } from './components/tonghop/maubaocaoedit.component'
import { importeditComponent } from './components/tonghop/importedit.component'
import { importqteditComponent } from './components/tonghop/importqtedit.component'
import { hanghoaeditComponent } from './components/danhmuc/hanghoaedit.component'
import { hopdongeditComponent } from './components/danhmuc/hopdongedit.component'
import { taisaneditComponent } from './components/danhmuc/taisanedit.component'
import { nguonkinhphieditComponent } from './components/danhmuc/nguonkinhphiedit.component'
import { tuychinhmaubceditComponent } from './components/tonghop/tuychinhmaubcedit.component'
import { dvckbnneditComponent } from './components/thamsobaocao/dvckbnnedit.component'
import { giayrutdutoan02aeditComponent } from './components/thamsobaocao/giayrutdutoan02aedit.component'
import { giayrutdutoan02beditComponent } from './components/thamsobaocao/giayrutdutoan02bedit.component'
import { giayrutvondautu16b1editComponent } from './components/thamsobaocao/giayrutvondautu16b1edit.component'
import { doituongthuhuong09editComponent } from './components/thamsobaocao/doituongthuhuong09edit.component'
import { phieudieuchinheditComponent } from './components/thamsobaocao/phieudieuchinhedit.component'
import { giaynoptrakinhphi06editComponent } from './components/thamsobaocao/giaynoptrakinhphi06edit.component'
import { uynhiemchic402ceditComponent } from './components/thamsobaocao/uynhiemchic402cedit.component'
import { giaydenghirutvondautu_mau11editComponent } from './components/thamsobaocao/giaydenghirutvondautu_mau11edit.component'
import { phieukiemketaisaneditComponent } from './components/thamsobaocao/phieukiemketaisanedit.component'
import { sinhsolieuquyettoanComponent } from './components/tonghop/sinhsolieuquyettoan.component'
import { giayrutdutoanc2_02aeditComponent } from './components/thamsobaocao02/giayrutdutoanc2_02aedit.component'
import { giayrutdutoanc2_02beditComponent } from './components/thamsobaocao02/giayrutdutoanc2_02bedit.component'



import { bangkethanhtoan_tt39editComponent } from './components/thamsobaocao/bangkethanhtoan_tt39edit.component'
import { giaydenghithanhtoan_c2_03editComponent } from './components/thamsobaocao/giaydenghithanhtoan_c2_03edit.component'
import { uynhiemchic402aeditComponent } from './components/thamsobaocao/uynhiemchic402aedit.component'

import { uynhiemchic4_02ceditComponent } from './components/thamsobaocao02/uynhiemchic4_02cedit.component'
import { uynhiemchic4_02aeditComponent } from './components/thamsobaocao02/uynhiemchic4_02aedit.component'



import { giayruttienmatc4_09_kbeditComponent } from './components/thamsobaocao/giayruttienmatc4_09_kbedit.component'
import { giaydenghithanhtoanc37hdeditComponent } from './components/thamsobaocao/giaydenghithanhtoanc37hdedit.component'
import { luoichitieteditComponent } from './components/tonghop/luoichitietedit.component'
import { luoitonghopeditComponent } from './components/tonghop/luoitonghopedit.component'
import { donvieditComponent } from './components/quantri/donviedit.component'
import { phanheeditComponent } from './components/quantri/phanheedit.component'
import { hachtoanluongeditComponent } from './components/ketoan/hachtoanluongedit.component'
import { traluongeditComponent } from './components/ketoan/traluongedit.component'
import { nopbaohiemeditComponent } from './components/ketoan/nopbaohiemedit.component'
import { dsdinhkhoanmauComponent } from './components/ketoan/dsdinhkhoanmau.component'
import { chungtuchungeditComponent } from './components/ketoan/chungtuchungedit.component'
import { chikhongtuchueditComponent } from './components/dutoan/chikhongtuchuedit.component'
import { chikhongtuchudmeditComponent } from './components/dutoan/chikhongtuchudmedit.component'
import { chikhongtuchudmthietbieditComponent } from './components/dutoan/chikhongtuchudmthietbiedit.component'
import { chikhongtuchuhneditComponent } from './components/dutoan/chikhongtuchuhnedit.component'
import { phanboeditComponent } from './components/dutoan/phanboedit.component'
import { suachuaeditComponent } from './components/dutoan/suachuaedit.component'
import { tinhgianbiencheeditComponent } from './components/dutoan/tinhgianbiencheedit.component'
import { dsloaikhoaneditComponent } from './components/tonghop/dsloaikhoanedit.component'

import { chonchungtueditComponent } from './components/tonghop/chonchungtuedit.component'
import { hosochungtueditComponent } from './components/tonghop/hosochungtuedit.component'
import { chondoituongeditComponent } from './components/tonghop/chondoituongedit.component'
import { cauhinhketchuyentt24editComponent } from './components/tonghop/cauhinhketchuyentt24edit.component'

import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { NgxCurrencyModule } from "./directives/currencymask/currency-mask.module";
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FormatChatMessagePipe } from './pipes/format-chat-message.pipe';

import { FlotDirective } from './directives/flot/flot.directive';
//import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';
import { FileUploadModule } from 'ng2-file-upload';

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
       
        CollapseModule.forRoot(),
      Ng2SmartTableModule,
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
      NgxLoadingModule.forRoot({}),
      TabsModule.forRoot(),
      Ng2Bs3ModalModule,
      DateInputsModule,
      NgxCurrencyModule,
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        TypeaheadModule.forRoot(),
        NgSelectModule,
        TextMaskModule,
      ToasterModule,
      UploadModule,
      FileUploadModule
    ],
    providers: [
        ColorsService,
        TabService,
        Repository,
        ToasterService,
        AuthorizationService,
    ],
    declarations: [
      FlotDirective,
      EasypiechartDirective,
      AutofocusDirective,
      NumericDirective,
        TabDirective,
        NumberViewComponent,
      ButtonViewComponent,
      LinkViewComponent,
        DateViewComponent,
        RowExpandViewComponent,
        RowHoaHongViewComponent,
        HideIfUnauthorizedDirective,
        DisableIfUnauthorizedDirective,
      doituongchungeditComponent,
      doituongdichvueditComponent,
        canboeditComponent,
      khachhangeditComponent,
      phieuthueditComponent,
      phieuchieditComponent,
      baocoeditComponent,
      baonoeditComponent,
      nhandutoaneditComponent,
      huydutoaneditComponent,
      dcdutoaneditComponent,
      rutdutoantmeditComponent,
      rutdutoantgeditComponent,
      chungtukhaceditComponent,
      rutdutoanckeditComponent,
      nganhangeditComponent,
      maubaocaoeditComponent,
      bangkethanhtoaneditComponent,
      dckinhphieditComponent,
      bamgkectuComponent,
      cknoiboeditComponent,
      importeditComponent,
      importqteditComponent,
      camketchieditComponent,
      hanghoaeditComponent,
      hopdongeditComponent,
      taisaneditComponent,
      dccamketchieditComponent,
      loccamketchiComponent,
      nguonkinhphieditComponent,
      tuychinhmaubceditComponent,
      dvckbnneditComponent,
      giayrutdutoan02aeditComponent,
      giudutoaneditComponent,
      giayrutdutoan02beditComponent,
      giayrutvondautu16b1editComponent,
      loaitaisaneditComponent,
      taikhoanketchuyeneditComponent,
      bangkethanhtoan_tt39editComponent,
      giaydenghithanhtoan_c2_03editComponent,
      uynhiemchic402aeditComponent,
      uynhiemchic4_02aeditComponent,
      uynhiemchic4_02ceditComponent,
      giayruttienmatc4_09_kbeditComponent,
      giaydenghithanhtoanc37hdeditComponent,
      doituongthuhuong09editComponent,
      phieukiemketaisaneditComponent,
      sinhsolieuquyettoanComponent,
      giayrutdutoanc2_02aeditComponent,
      giayrutdutoanc2_02beditComponent,
      phieudieuchinheditComponent,
      giaynoptrakinhphi06editComponent,
      uynhiemchic402ceditComponent,
      giaydenghirutvondautu_mau11editComponent,

      cktaisaneditComponent,
      nhantaisaneditComponent,
      bantaisaneditComponent,
      luoichitieteditComponent,
      luoitonghopeditComponent,
      haomoneditComponent,
      nhapkhoeditComponent,
      congcueditComponent,
      donvieditComponent,
      phanheeditComponent,
      xuatkhoeditComponent,
      ghitangcongcueditComponent,
      ghigiamcongcueditComponent,
      dccongcueditComponent,
      dctaisaneditComponent,
      phongbaneditComponent,
      chuyentieptaisaneditComponent,
      phanbocongcueditComponent,
      muacongcueditComponent,
      noptncnceditComponent,
      hachtoanluongeditComponent,
      traluongeditComponent,
      nopbaohiemeditComponent,
      dsdinhkhoanmauComponent,
      chungtuchungeditComponent,
      chikhongtuchueditComponent,
      chikhongtuchudmeditComponent,
      chikhongtuchudmthietbieditComponent,
      chikhongtuchuhneditComponent,
      phanboeditComponent,
      suachuaeditComponent,
      tinhgianbiencheeditComponent,
      dsloaikhoaneditComponent,
      chonchungtueditComponent,
      hosochungtueditComponent,
      chondoituongeditComponent,
      cauhinhketchuyentt24editComponent,
      FormatChatMessagePipe,
    ],
    entryComponents: [        
        NumberViewComponent,
      ButtonViewComponent,
      LinkViewComponent,
        DateViewComponent,
        RowExpandViewComponent,
        RowHoaHongViewComponent,
      doituongchungeditComponent,
      doituongdichvueditComponent,
        canboeditComponent,
      khachhangeditComponent,
      phieuthueditComponent,
      phieuchieditComponent,
      baocoeditComponent,
      baonoeditComponent,
      nhandutoaneditComponent,
      huydutoaneditComponent,
      dcdutoaneditComponent,
      rutdutoantmeditComponent,
      rutdutoantgeditComponent,
      chungtukhaceditComponent,
      rutdutoanckeditComponent,
      nganhangeditComponent,
      bangkethanhtoaneditComponent,
      dckinhphieditComponent,
      bamgkectuComponent,
      maubaocaoeditComponent,
      cknoiboeditComponent,
      importeditComponent,
      importqteditComponent,
      camketchieditComponent,
      hanghoaeditComponent,
      hopdongeditComponent,
      taisaneditComponent,
      dccamketchieditComponent,
      loccamketchiComponent,
      nguonkinhphieditComponent,
      tuychinhmaubceditComponent,
      dvckbnneditComponent,
      giayrutdutoan02aeditComponent,
      giudutoaneditComponent,
      giayrutdutoan02beditComponent,
      giayrutvondautu16b1editComponent,
      loaitaisaneditComponent,
      taikhoanketchuyeneditComponent,
      bangkethanhtoan_tt39editComponent,
      giaydenghithanhtoan_c2_03editComponent,
      uynhiemchic402aeditComponent,
      uynhiemchic4_02aeditComponent,
      uynhiemchic4_02ceditComponent,
      giayruttienmatc4_09_kbeditComponent,
      giaydenghithanhtoanc37hdeditComponent,
      doituongthuhuong09editComponent,
      phieukiemketaisaneditComponent,
      sinhsolieuquyettoanComponent,
      giayrutdutoanc2_02aeditComponent,
      giayrutdutoanc2_02beditComponent,
      phieudieuchinheditComponent,
      giaynoptrakinhphi06editComponent,
      uynhiemchic402ceditComponent,
      giaydenghirutvondautu_mau11editComponent,

      cktaisaneditComponent,
      nhantaisaneditComponent,
      bantaisaneditComponent,
      luoichitieteditComponent,
      luoitonghopeditComponent,
      haomoneditComponent,
      nhapkhoeditComponent,
      congcueditComponent,
      donvieditComponent,
      phanheeditComponent,
      xuatkhoeditComponent,
      ghitangcongcueditComponent,
      ghigiamcongcueditComponent,
      dccongcueditComponent,
      dctaisaneditComponent,
      phongbaneditComponent,
      chuyentieptaisaneditComponent,
      phanbocongcueditComponent,
      muacongcueditComponent,
      noptncnceditComponent,
      hachtoanluongeditComponent,
      traluongeditComponent,
      nopbaohiemeditComponent,
      dsdinhkhoanmauComponent,
      chungtuchungeditComponent,
      chikhongtuchueditComponent,
      chikhongtuchudmeditComponent,
      chikhongtuchudmthietbieditComponent,
      chikhongtuchuhneditComponent,
      phanboeditComponent,
      suachuaeditComponent,
      tinhgianbiencheeditComponent,
      dsloaikhoaneditComponent,
      chonchungtueditComponent,
      hosochungtueditComponent,
      chondoituongeditComponent,
      cauhinhketchuyentt24editComponent,
    ],
  exports: [
    FlotDirective,
    EasypiechartDirective,
    NgxCurrencyModule,
        CommonModule,
        FormsModule,
    NgSelectModule,
    FileUploadModule,
        TextMaskModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,       
        CollapseModule,      
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
      NgxLoadingModule,
        TabsModule,       
        TooltipModule,
        PopoverModule,
        TypeaheadModule,
        ToasterModule,
        TabDirective,
    AutofocusDirective,
    NumericDirective,
        HideIfUnauthorizedDirective,
        DisableIfUnauthorizedDirective,
    doituongchungeditComponent,
    doituongdichvueditComponent,
        canboeditComponent,
      khachhangeditComponent,
      phieuthueditComponent,
      phieuchieditComponent,
      baocoeditComponent,
      baonoeditComponent,
      nhandutoaneditComponent,
      huydutoaneditComponent,
      dcdutoaneditComponent,
      rutdutoantmeditComponent,
      rutdutoantgeditComponent,
      chungtukhaceditComponent,
      rutdutoanckeditComponent,
      nganhangeditComponent,
    bangkethanhtoaneditComponent,
    dckinhphieditComponent,
      bamgkectuComponent,
      maubaocaoeditComponent,
      cknoiboeditComponent,
    importeditComponent,
    importqteditComponent,
      camketchieditComponent,
      hanghoaeditComponent,
      hopdongeditComponent,
      taisaneditComponent,
      dccamketchieditComponent,
      loccamketchiComponent,
      nguonkinhphieditComponent,
    tuychinhmaubceditComponent,
    dvckbnneditComponent,
      giayrutdutoan02aeditComponent,
      giudutoaneditComponent,
    giayrutdutoan02beditComponent,
    giayrutvondautu16b1editComponent,
    loaitaisaneditComponent,
    taikhoanketchuyeneditComponent,
    bangkethanhtoan_tt39editComponent,
    giaydenghithanhtoan_c2_03editComponent,
    uynhiemchic402aeditComponent,
    uynhiemchic4_02aeditComponent,
    uynhiemchic4_02ceditComponent,
    giayruttienmatc4_09_kbeditComponent,
    giaydenghithanhtoanc37hdeditComponent,
    doituongthuhuong09editComponent,
    phieukiemketaisaneditComponent,
    sinhsolieuquyettoanComponent,
    giayrutdutoanc2_02aeditComponent,
    giayrutdutoanc2_02beditComponent,
    phieudieuchinheditComponent,
    giaynoptrakinhphi06editComponent,
    uynhiemchic402ceditComponent,
    giaydenghirutvondautu_mau11editComponent,

      cktaisaneditComponent,
      nhantaisaneditComponent,
      bantaisaneditComponent,
      luoichitieteditComponent,
      luoitonghopeditComponent,
      haomoneditComponent,
      nhapkhoeditComponent,
      congcueditComponent,
      donvieditComponent,
      phanheeditComponent,
      xuatkhoeditComponent,
      ghitangcongcueditComponent,
      ghigiamcongcueditComponent,
    dccongcueditComponent,
    dctaisaneditComponent,
    phongbaneditComponent,
    chuyentieptaisaneditComponent,
    phanbocongcueditComponent,
    muacongcueditComponent,
    noptncnceditComponent,
    hachtoanluongeditComponent,
    traluongeditComponent,
    nopbaohiemeditComponent,
    dsdinhkhoanmauComponent,
    chungtuchungeditComponent,
    chikhongtuchueditComponent,
    chikhongtuchudmeditComponent,
    chikhongtuchudmthietbieditComponent,
    chikhongtuchuhneditComponent,
    phanboeditComponent,
    suachuaeditComponent,
    tinhgianbiencheeditComponent,
    dsloaikhoaneditComponent,
    chonchungtueditComponent,
    hosochungtueditComponent,
    chondoituongeditComponent,
    cauhinhketchuyentt24editComponent,
    FormatChatMessagePipe,
    ]
})


export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}
